exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tileHeader[data-v-a2400126] {\n  background: rgb(225, 249, 255);\n}\n.tileContent[data-v-a2400126] {\n  background: '' /* rgb(238, 255, 204) */;\n}\n.tileHeaderAlert[data-v-a2400126] {\n  background: rgb(248, 156, 145);\n}\n@media screen and (max-width: 960px) {\n#clockCheck .hideMobile[data-v-a2400126] {\n    display: none;\n}\n#clockCheck .alignment[data-v-a2400126] {\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n}\n", ""]);

// exports
